import request from '@/api/index'

export function validate(data) {
  return request({
    url: '/guarantee/validate',
    method: 'post',
    data
  })
}

export function querySingle(id){
  return request({
    url:'/guarantee/querySingle/'+id,
    method:'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/guarantee.js